import { Injectable, inject } from "@angular/core";
import { ApiService } from "app/core/api/api.service";
import { Observable, forkJoin, map, of } from "rxjs";
import {
  CourtUnavailability,
  CourtUnavailabilityRequest,
} from "./court-unavailability.types";

@Injectable({ providedIn: "root" })
export class CourtUnavailabilityService {
  private readonly api = inject(ApiService);

  list(
    venueId: string,
    courtId: string,
    from: string,
    to: string,
  ): Observable<CourtUnavailability[]> {
    const query = new URLSearchParams({ from, to });
    return this.api
      .get(
        `venue/${venueId}/courts/${courtId}/unavailability?${query.toString()}`,
      )
      .pipe(map((response: any) => response?.results ?? []));
  }

  listForCourts(
    venueId: string,
    courtIds: string[],
    from: string,
    to: string,
  ): Observable<CourtUnavailability[]> {
    if (!courtIds.length || !from || !to) return of([]);
    return forkJoin(
      courtIds.map((courtId) => this.list(venueId, courtId, from, to)),
    ).pipe(map((results) => results.flat()));
  }

  create(
    venueId: string,
    courtId: string,
    request: CourtUnavailabilityRequest,
  ): Observable<CourtUnavailability> {
    return this.api.post(
      `venue/${venueId}/courts/${courtId}/unavailability`,
      request,
    );
  }

  update(
    venueId: string,
    courtId: string,
    id: string,
    request: CourtUnavailabilityRequest,
  ): Observable<CourtUnavailability> {
    return this.api.patch(
      `venue/${venueId}/courts/${courtId}/unavailability/${id}`,
      request,
    );
  }

  cancel(
    venueId: string,
    courtId: string,
    id: string,
  ): Observable<CourtUnavailability> {
    return this.api.post(
      `venue/${venueId}/courts/${courtId}/unavailability/${id}/cancel`,
      {},
    );
  }
}
